import type { CallInfo } from '@compass/client/types/call';
import { WorkflowState } from '@compass/client/types/case_record';
import type { Evaluation } from '@compass/client/types/evaluation';
import React from 'react';

import { FormattedDateRelative } from '@/components/FormattedDateRelative';
import { Badge } from '@/components/ui/badge';

import { getCallDateTimeValue } from '../qcDetail.utils';

interface QcDetailHeaderProps {
  evaluation: Evaluation;
  agentName?: string | null;
  programName?: string | null;
  call?: CallInfo | null;
}

export const QcDetailHeader: React.FC<QcDetailHeaderProps> = ({
  evaluation,
  agentName,
  programName,
  call,
}) => {
  const callDateTime = getCallDateTimeValue(call);
  const hasReviewerFindingReviews = Object.keys(evaluation.reviews?.findings || {}).length > 0;
  const workflowBadge =
    evaluation.workflow_state === WorkflowState.WORKFLOW_STATE_RUNNING ? (
      <Badge variant="secondary">Re-evaluating</Badge>
    ) : hasReviewerFindingReviews &&
      (evaluation.workflow_state === WorkflowState.WORKFLOW_STATE_STOPPED ||
        evaluation.workflow_state === WorkflowState.WORKFLOW_STATE_CANCELLED) ? (
      <Badge variant="destructive">Re-eval failed</Badge>
    ) : null;

  return (
    <div className="flex items-center justify-end gap-2 border-b bg-background px-4 py-2">
      <div className="flex items-center gap-2 text-sm text-muted-foreground">
        {workflowBadge}
        {agentName && <span className="font-medium text-foreground">{agentName}</span>}
        {programName && <Badge variant="secondary">{programName}</Badge>}
        {(agentName || programName) && callDateTime && <span>&bull;</span>}
        {callDateTime && <FormattedDateRelative value={callDateTime} />}
      </div>
    </div>
  );
};
